import React from 'react';
import AnimatedSection from './AnimatedSection';

/**
 * Shared shell for legal / utility pages: hero + main content area.
 * @param {Object} props
 * @param {string} props.title - Page H1
 * @param {string} [props.eyebrow] - Small label above title
 * @param {string} [props.meta] - Subline (e.g. last updated)
 * @param {string} [props.lead] - Optional intro under meta (hero)
 * @param {'default'|'wide'} [props.variant] - default = narrow prose column; wide = sitemap-style full container
 * @param {React.ReactNode} props.children
 */
const UtilityPageLayout = ({
  title,
  eyebrow,
  meta,
  lead,
  variant = 'default',
  children
}) => {
  const mainClass =
    variant === 'wide'
      ? 'utility-page-main utility-page-main--wide'
      : 'utility-page-main';

  return (
    <>
      <section className="utility-page-hero">
        <div className="utility-page-hero__bg" aria-hidden="true">
          <img
            src="https://picsum.photos/seed/utility-legal/1920/480"
            alt=""
            className="utility-page-hero__img"
          />
          <div className="utility-page-hero__overlay" />
        </div>
        <div className="container utility-page-hero__inner">
          {eyebrow ? (
            <p className="utility-page-hero__eyebrow">{eyebrow}</p>
          ) : null}
          <h1 className="utility-page-hero__title">{title}</h1>
          {meta ? <p className="utility-page-hero__meta">{meta}</p> : null}
          {lead ? <p className="utility-page-hero__lead">{lead}</p> : null}
        </div>
      </section>

      <section className={mainClass}>
        <div
          className={
            variant === 'wide'
              ? 'container utility-page-container utility-page-container--wide'
              : 'container utility-page-container'
          }
        >
          {variant === 'wide' ? (
            <AnimatedSection variant="fadeUp">{children}</AnimatedSection>
          ) : (
            <div className="utility-page-inner">
              <AnimatedSection variant="fadeUp">{children}</AnimatedSection>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default UtilityPageLayout;
